import { hasValue } from './type';

/**
 * Constructs REST URL with the given url and prefix.
 *
 * @param url rest url
 * @param prefix to be added before the url
 */
export const constructRestUrl = (url: string, prefix?: string): string =>
  `rest/${hasValue(prefix) ? prefix + '/' : ''}${url}`;
